import React from "react";
import "../About/Security.css";
import { FaShieldAlt, FaGlobe } from "react-icons/fa";

const Security = () => {
  return (
    <section className="security-section">
      <div className="security-wrapper">
        {/* IMAGE SIDE */}
        <div className="security-image">
          <img src="/aboutse.webp" alt="Travel Security & Protection" />
        </div>

        {/* CONTENT SIDE */}
        <div className="security-content">
          <h2>Your Security is Our Priority</h2>

          <p className="security-intro">
            Booking with Click4Flight means booking with total confidence.
          </p>

          <div className="security-points">
            <div className="security-point">
              <FaShieldAlt />
              <p>
                <strong>Comprehensive Protection:</strong> Every
                flight-inclusive holiday we sell is ATOL Protected through the
                Civil Aviation Authority under Journey Experts Ltd (ATOL
                #11037).
              </p>
            </div>

            <div className="security-point">
              <FaGlobe />
              <p>
                <strong>Global Support:</strong> Our commitment to you doesn't
                end when you receive your tickets. Our global support network is
                available to assist you at every stage of your journey.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Security;
